/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as protectedRouteRouteImport } from './routes/(protected)/route'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as protectedIndexRouteImport } from './routes/(protected)/index'
import { Route as IntegrationsGithubAppCallbackRouteImport } from './routes/integrations/github-app-callback'
import { Route as DemoPulseRouteImport } from './routes/demo/pulse'
import { Route as authVerifyEmailRouteImport } from './routes/(auth)/verify-email'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as authLogoutRouteImport } from './routes/(auth)/logout'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as authAcceptInvitationRouteImport } from './routes/(auth)/accept-invitation'
import { Route as protectedWorkspacesRouteRouteImport } from './routes/(protected)/workspaces/route'
import { Route as protectedSettingsRouteRouteImport } from './routes/(protected)/settings/route'
import { Route as protectedPartnerRouteRouteImport } from './routes/(protected)/partner/route'
import { Route as protectedOrgsRouteRouteImport } from './routes/(protected)/orgs/route'
import { Route as protectedOpsRouteRouteImport } from './routes/(protected)/ops/route'
import { Route as protectedFeatureBoardRouteRouteImport } from './routes/(protected)/feature-board/route'
import { Route as ExportSopPdfIndexRouteImport } from './routes/export/sop-pdf/index'
import { Route as ExportSopEmbedIndexRouteImport } from './routes/export/sop-embed/index'
import { Route as DemoTiptapIndexRouteImport } from './routes/demo/tiptap/index'
import { Route as protectedTasksIndexRouteImport } from './routes/(protected)/tasks/index'
import { Route as protectedSettingsIndexRouteImport } from './routes/(protected)/settings/index'
import { Route as protectedPartnerIndexRouteImport } from './routes/(protected)/partner/index'
import { Route as protectedOpsIndexRouteImport } from './routes/(protected)/ops/index'
import { Route as protectedFeatureBoardIndexRouteImport } from './routes/(protected)/feature-board/index'
import { Route as DemoTiptapAiSuggestionRouteImport } from './routes/demo/tiptap/ai-suggestion'
import { Route as DemoTiptapAiChangesRouteImport } from './routes/demo/tiptap/ai-changes'
import { Route as protectedWorkspacesNewRouteImport } from './routes/(protected)/workspaces/new'
import { Route as protectedSettingsWritingRouteImport } from './routes/(protected)/settings/writing'
import { Route as protectedSettingsThemeRouteImport } from './routes/(protected)/settings/theme'
import { Route as protectedSettingsTemplatesRouteImport } from './routes/(protected)/settings/templates'
import { Route as protectedSettingsSigningRouteImport } from './routes/(protected)/settings/signing'
import { Route as protectedSettingsSecurityRouteImport } from './routes/(protected)/settings/security'
import { Route as protectedSettingsReviewRouteImport } from './routes/(protected)/settings/review'
import { Route as protectedSettingsPublishingRouteImport } from './routes/(protected)/settings/publishing'
import { Route as protectedSettingsPropertiesRouteImport } from './routes/(protected)/settings/properties'
import { Route as protectedSettingsProfileRouteImport } from './routes/(protected)/settings/profile'
import { Route as protectedSettingsPersonasRouteImport } from './routes/(protected)/settings/personas'
import { Route as protectedSettingsOrganizationRouteImport } from './routes/(protected)/settings/organization'
import { Route as protectedSettingsMembersRouteImport } from './routes/(protected)/settings/members'
import { Route as protectedSettingsMcpServerRouteImport } from './routes/(protected)/settings/mcp-server'
import { Route as protectedSettingsGeneralRouteImport } from './routes/(protected)/settings/general'
import { Route as protectedSettingsDocTemplatesRouteImport } from './routes/(protected)/settings/doc-templates'
import { Route as protectedSettingsConfigurationRouteImport } from './routes/(protected)/settings/configuration'
import { Route as protectedSettingsChecksRouteImport } from './routes/(protected)/settings/checks'
import { Route as protectedSettingsChatRouteImport } from './routes/(protected)/settings/chat'
import { Route as protectedSettingsBrandingRouteImport } from './routes/(protected)/settings/branding'
import { Route as protectedSettingsBillingRouteImport } from './routes/(protected)/settings/billing'
import { Route as protectedSettingsAuthRouteImport } from './routes/(protected)/settings/auth'
import { Route as protectedSettingsAuditLogsRouteImport } from './routes/(protected)/settings/audit-logs'
import { Route as protectedSettingsApiKeysRouteImport } from './routes/(protected)/settings/api-keys'
import { Route as protectedDevPlanRestrictionsTestRouteImport } from './routes/(protected)/dev/plan-restrictions-test'
import { Route as authNativeLoginRouteImport } from './routes/(auth)/native/login'
import { Route as authNativeAuthCallbackRouteImport } from './routes/(auth)/native/auth-callback'
import { Route as authAuthCallbackProviderRouteImport } from './routes/(auth)/auth-callback/$provider'
import { Route as protectedWorkspacesWorkspaceIdRouteRouteImport } from './routes/(protected)/workspaces/$workspaceId/route'
import { Route as protectedOrgsSlugRouteRouteImport } from './routes/(protected)/orgs/$slug/route'
import { Route as protectedWorkspacesWorkspaceIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/index'
import { Route as protectedWorkspaceIntegrationsIndexRouteImport } from './routes/(protected)/workspace/integrations/index'
import { Route as protectedSettingsServiceAccountsIndexRouteImport } from './routes/(protected)/settings/service-accounts/index'
import { Route as protectedWorkspacesWorkspaceIdVideoProcessingRouteImport } from './routes/(protected)/workspaces/$workspaceId/video-processing'
import { Route as protectedWorkspacesWorkspaceIdEditRouteImport } from './routes/(protected)/workspaces/$workspaceId/edit'
import { Route as protectedWorkspacesWorkspaceIdAnalyticsRouteImport } from './routes/(protected)/workspaces/$workspaceId/analytics'
import { Route as protectedWorkspaceIntegrationsGithubRouteImport } from './routes/(protected)/workspace/integrations/github'
import { Route as protectedPartnerClientsNewRouteImport } from './routes/(protected)/partner/clients/new'
import { Route as protectedPartnerClientsClientIdRouteImport } from './routes/(protected)/partner/clients/$clientId'
import { Route as protectedWorkspacesWorkspaceIdSopsIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/sops/index'
import { Route as protectedWorkspacesWorkspaceIdPulseIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/pulse/index'
import { Route as protectedWorkspacesWorkspaceIdDashboardIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/dashboard/index'
import { Route as protectedWorkspacesWorkspaceIdPulseConfigureRouteImport } from './routes/(protected)/workspaces/$workspaceId/pulse/configure'
import { Route as protectedWorkspacesWorkspaceIdStepsIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/steps/$id/index'
import { Route as protectedWorkspacesWorkspaceIdSopsSopIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/sops/$sopId/index'
import { Route as protectedWorkspacesWorkspaceIdSopsSopIdGenerateRouteImport } from './routes/(protected)/workspaces/$workspaceId/sops/$sopId/generate'

const ExtensionUninstalledLazyRouteImport = createFileRoute(
  '/extension-uninstalled',
)()
const SharedSopShareIdLazyRouteImport = createFileRoute(
  '/shared-sop/$shareId',
)()
const errors503LazyRouteImport = createFileRoute('/(errors)/503')()
const errors500LazyRouteImport = createFileRoute('/(errors)/500')()
const errors404LazyRouteImport = createFileRoute('/(errors)/404')()
const errors403LazyRouteImport = createFileRoute('/(errors)/403')()
const errors401LazyRouteImport = createFileRoute('/(errors)/401')()
const authVerifyOtpLazyRouteImport = createFileRoute('/(auth)/verify-otp')()
const authVerify2faLazyRouteImport = createFileRoute('/(auth)/verify-2fa')()
const authSignupLazyRouteImport = createFileRoute('/(auth)/signup')()
const authLogin2LazyRouteImport = createFileRoute('/(auth)/login-2')()
const authForgotPasswordLazyRouteImport = createFileRoute(
  '/(auth)/forgot-password',
)()
const protectedWorkspacesIndexLazyRouteImport = createFileRoute(
  '/(protected)/workspaces/',
)()
const protectedTeamIndexLazyRouteImport =
  createFileRoute('/(protected)/team/')()
const protectedOrgsIndexLazyRouteImport =
  createFileRoute('/(protected)/orgs/')()
const protectedOnboardingIndexLazyRouteImport = createFileRoute(
  '/(protected)/onboarding/',
)()
const protectedIntegrationsIndexLazyRouteImport = createFileRoute(
  '/(protected)/integrations/',
)()
const protectedWorkspacesWorkspaceIdGitSettingsLazyRouteImport =
  createFileRoute('/(protected)/workspaces/$workspaceId/git-settings')()
const protectedWorkspacesWorkspaceIdAgentReliabilityLazyRouteImport =
  createFileRoute('/(protected)/workspaces/$workspaceId/agent-reliability')()
const protectedOnboardingOrganizationIdWorkspaceLazyRouteImport =
  createFileRoute('/(protected)/onboarding/$organizationId/workspace')()
const protectedWorkspacesWorkspaceIdStepsIndexLazyRouteImport = createFileRoute(
  '/(protected)/workspaces/$workspaceId/steps/',
)()
const protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRouteImport =
  createFileRoute('/(protected)/workspaces/$workspaceId/integrations/')()
const protectedWorkspacesWorkspaceIdFlowsIndexLazyRouteImport = createFileRoute(
  '/(protected)/workspaces/$workspaceId/flows/',
)()
const protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRouteImport =
  createFileRoute('/(protected)/workspaces/$workspaceId/flows/$flowId/view')()

const ExtensionUninstalledLazyRoute =
  ExtensionUninstalledLazyRouteImport.update({
    id: '/extension-uninstalled',
    path: '/extension-uninstalled',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/extension-uninstalled.lazy').then((d) => d.Route),
  )
const protectedRouteRoute = protectedRouteRouteImport.update({
  id: '/(protected)',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const protectedIndexRoute = protectedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const SharedSopShareIdLazyRoute = SharedSopShareIdLazyRouteImport.update({
  id: '/shared-sop/$shareId',
  path: '/shared-sop/$shareId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/shared-sop.$shareId.lazy').then((d) => d.Route),
)
const errors503LazyRoute = errors503LazyRouteImport
  .update({
    id: '/(errors)/503',
    path: '/503',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/503.lazy').then((d) => d.Route))
const errors500LazyRoute = errors500LazyRouteImport
  .update({
    id: '/(errors)/500',
    path: '/500',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/500.lazy').then((d) => d.Route))
const errors404LazyRoute = errors404LazyRouteImport
  .update({
    id: '/(errors)/404',
    path: '/404',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/404.lazy').then((d) => d.Route))
const errors403LazyRoute = errors403LazyRouteImport
  .update({
    id: '/(errors)/403',
    path: '/403',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/403.lazy').then((d) => d.Route))
const errors401LazyRoute = errors401LazyRouteImport
  .update({
    id: '/(errors)/401',
    path: '/401',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/401.lazy').then((d) => d.Route))
const authVerifyOtpLazyRoute = authVerifyOtpLazyRouteImport
  .update({
    id: '/verify-otp',
    path: '/verify-otp',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/verify-otp.lazy').then((d) => d.Route))
const authVerify2faLazyRoute = authVerify2faLazyRouteImport
  .update({
    id: '/verify-2fa',
    path: '/verify-2fa',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/verify-2fa.lazy').then((d) => d.Route))
const authSignupLazyRoute = authSignupLazyRouteImport
  .update({
    id: '/signup',
    path: '/signup',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/signup.lazy').then((d) => d.Route))
const authLogin2LazyRoute = authLogin2LazyRouteImport
  .update({
    id: '/login-2',
    path: '/login-2',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/login-2.lazy').then((d) => d.Route))
const authForgotPasswordLazyRoute = authForgotPasswordLazyRouteImport
  .update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(auth)/forgot-password.lazy').then((d) => d.Route),
  )
const IntegrationsGithubAppCallbackRoute =
  IntegrationsGithubAppCallbackRouteImport.update({
    id: '/integrations/github-app-callback',
    path: '/integrations/github-app-callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const DemoPulseRoute = DemoPulseRouteImport.update({
  id: '/demo/pulse',
  path: '/demo/pulse',
  getParentRoute: () => rootRouteImport,
} as any)
const authVerifyEmailRoute = authVerifyEmailRouteImport
  .update({
    id: '/verify-email',
    path: '/verify-email',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/verify-email.lazy').then((d) => d.Route))
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => authRouteRoute,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/otp',
  path: '/otp',
  getParentRoute: () => authRouteRoute,
} as any)
const authLogoutRoute = authLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => authRouteRoute,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authRouteRoute,
} as any)
const authAcceptInvitationRoute = authAcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => authRouteRoute,
} as any)
const protectedWorkspacesRouteRoute =
  protectedWorkspacesRouteRouteImport.update({
    id: '/workspaces',
    path: '/workspaces',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSettingsRouteRoute = protectedSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedPartnerRouteRoute = protectedPartnerRouteRouteImport.update({
  id: '/partner',
  path: '/partner',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedOrgsRouteRoute = protectedOrgsRouteRouteImport.update({
  id: '/orgs',
  path: '/orgs',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedOpsRouteRoute = protectedOpsRouteRouteImport.update({
  id: '/ops',
  path: '/ops',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedFeatureBoardRouteRoute =
  protectedFeatureBoardRouteRouteImport.update({
    id: '/feature-board',
    path: '/feature-board',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedWorkspacesIndexLazyRoute =
  protectedWorkspacesIndexLazyRouteImport
    .update({
      id: '/',
      path: '/',
      getParentRoute: () => protectedWorkspacesRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/index.lazy').then((d) => d.Route),
    )
const protectedTeamIndexLazyRoute = protectedTeamIndexLazyRouteImport
  .update({
    id: '/team/',
    path: '/team/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(protected)/team/index.lazy').then((d) => d.Route),
  )
const protectedOrgsIndexLazyRoute = protectedOrgsIndexLazyRouteImport
  .update({
    id: '/',
    path: '/',
    getParentRoute: () => protectedOrgsRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(protected)/orgs/index.lazy').then((d) => d.Route),
  )
const protectedOnboardingIndexLazyRoute =
  protectedOnboardingIndexLazyRouteImport
    .update({
      id: '/onboarding/',
      path: '/onboarding/',
      getParentRoute: () => protectedRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/onboarding/index.lazy').then((d) => d.Route),
    )
const protectedIntegrationsIndexLazyRoute =
  protectedIntegrationsIndexLazyRouteImport
    .update({
      id: '/integrations/',
      path: '/integrations/',
      getParentRoute: () => protectedRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/integrations/index.lazy').then(
        (d) => d.Route,
      ),
    )
const ExportSopPdfIndexRoute = ExportSopPdfIndexRouteImport.update({
  id: '/export/sop-pdf/',
  path: '/export/sop-pdf/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportSopEmbedIndexRoute = ExportSopEmbedIndexRouteImport.update({
  id: '/export/sop-embed/',
  path: '/export/sop-embed/',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoTiptapIndexRoute = DemoTiptapIndexRouteImport.update({
  id: '/demo/tiptap/',
  path: '/demo/tiptap/',
  getParentRoute: () => rootRouteImport,
} as any)
const protectedTasksIndexRoute = protectedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedSettingsIndexRoute = protectedSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => protectedSettingsRouteRoute,
} as any)
const protectedPartnerIndexRoute = protectedPartnerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => protectedPartnerRouteRoute,
} as any)
const protectedOpsIndexRoute = protectedOpsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => protectedOpsRouteRoute,
} as any)
const protectedFeatureBoardIndexRoute =
  protectedFeatureBoardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => protectedFeatureBoardRouteRoute,
  } as any)
const DemoTiptapAiSuggestionRoute = DemoTiptapAiSuggestionRouteImport.update({
  id: '/demo/tiptap/ai-suggestion',
  path: '/demo/tiptap/ai-suggestion',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoTiptapAiChangesRoute = DemoTiptapAiChangesRouteImport.update({
  id: '/demo/tiptap/ai-changes',
  path: '/demo/tiptap/ai-changes',
  getParentRoute: () => rootRouteImport,
} as any)
const protectedWorkspacesNewRoute = protectedWorkspacesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => protectedWorkspacesRouteRoute,
} as any)
const protectedSettingsWritingRoute =
  protectedSettingsWritingRouteImport.update({
    id: '/writing',
    path: '/writing',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsThemeRoute = protectedSettingsThemeRouteImport.update({
  id: '/theme',
  path: '/theme',
  getParentRoute: () => protectedSettingsRouteRoute,
} as any)
const protectedSettingsTemplatesRoute =
  protectedSettingsTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsSigningRoute =
  protectedSettingsSigningRouteImport.update({
    id: '/signing',
    path: '/signing',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsSecurityRoute =
  protectedSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsReviewRoute = protectedSettingsReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => protectedSettingsRouteRoute,
} as any)
const protectedSettingsPublishingRoute =
  protectedSettingsPublishingRouteImport.update({
    id: '/publishing',
    path: '/publishing',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsPropertiesRoute =
  protectedSettingsPropertiesRouteImport.update({
    id: '/properties',
    path: '/properties',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsProfileRoute =
  protectedSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsPersonasRoute =
  protectedSettingsPersonasRouteImport.update({
    id: '/personas',
    path: '/personas',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsOrganizationRoute =
  protectedSettingsOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsMembersRoute =
  protectedSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsMcpServerRoute =
  protectedSettingsMcpServerRouteImport.update({
    id: '/mcp-server',
    path: '/mcp-server',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsGeneralRoute =
  protectedSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsDocTemplatesRoute =
  protectedSettingsDocTemplatesRouteImport.update({
    id: '/doc-templates',
    path: '/doc-templates',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsConfigurationRoute =
  protectedSettingsConfigurationRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsChecksRoute = protectedSettingsChecksRouteImport.update({
  id: '/checks',
  path: '/checks',
  getParentRoute: () => protectedSettingsRouteRoute,
} as any)
const protectedSettingsChatRoute = protectedSettingsChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => protectedSettingsRouteRoute,
} as any)
const protectedSettingsBrandingRoute =
  protectedSettingsBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsBillingRoute =
  protectedSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsAuthRoute = protectedSettingsAuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => protectedSettingsRouteRoute,
} as any)
const protectedSettingsAuditLogsRoute =
  protectedSettingsAuditLogsRouteImport.update({
    id: '/audit-logs',
    path: '/audit-logs',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedSettingsApiKeysRoute =
  protectedSettingsApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedDevPlanRestrictionsTestRoute =
  protectedDevPlanRestrictionsTestRouteImport.update({
    id: '/dev/plan-restrictions-test',
    path: '/dev/plan-restrictions-test',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const authNativeLoginRoute = authNativeLoginRouteImport.update({
  id: '/native/login',
  path: '/native/login',
  getParentRoute: () => authRouteRoute,
} as any)
const authNativeAuthCallbackRoute = authNativeAuthCallbackRouteImport.update({
  id: '/native/auth-callback',
  path: '/native/auth-callback',
  getParentRoute: () => authRouteRoute,
} as any)
const authAuthCallbackProviderRoute =
  authAuthCallbackProviderRouteImport.update({
    id: '/auth-callback/$provider',
    path: '/auth-callback/$provider',
    getParentRoute: () => authRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdRouteRoute =
  protectedWorkspacesWorkspaceIdRouteRouteImport.update({
    id: '/$workspaceId',
    path: '/$workspaceId',
    getParentRoute: () => protectedWorkspacesRouteRoute,
  } as any)
const protectedOrgsSlugRouteRoute = protectedOrgsSlugRouteRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => protectedOrgsRouteRoute,
} as any)
const protectedWorkspacesWorkspaceIdIndexRoute =
  protectedWorkspacesWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspaceIntegrationsIndexRoute =
  protectedWorkspaceIntegrationsIndexRouteImport.update({
    id: '/workspace/integrations/',
    path: '/workspace/integrations/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedSettingsServiceAccountsIndexRoute =
  protectedSettingsServiceAccountsIndexRouteImport.update({
    id: '/service-accounts/',
    path: '/service-accounts/',
    getParentRoute: () => protectedSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdGitSettingsLazyRoute =
  protectedWorkspacesWorkspaceIdGitSettingsLazyRouteImport
    .update({
      id: '/git-settings',
      path: '/git-settings',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/git-settings.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute =
  protectedWorkspacesWorkspaceIdAgentReliabilityLazyRouteImport
    .update({
      id: '/agent-reliability',
      path: '/agent-reliability',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/agent-reliability.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedOnboardingOrganizationIdWorkspaceLazyRoute =
  protectedOnboardingOrganizationIdWorkspaceLazyRouteImport
    .update({
      id: '/onboarding/$organizationId/workspace',
      path: '/onboarding/$organizationId/workspace',
      getParentRoute: () => protectedRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/onboarding/$organizationId.workspace.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdVideoProcessingRoute =
  protectedWorkspacesWorkspaceIdVideoProcessingRouteImport.update({
    id: '/video-processing',
    path: '/video-processing',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEditRoute =
  protectedWorkspacesWorkspaceIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdAnalyticsRoute =
  protectedWorkspacesWorkspaceIdAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspaceIntegrationsGithubRoute =
  protectedWorkspaceIntegrationsGithubRouteImport.update({
    id: '/workspace/integrations/github',
    path: '/workspace/integrations/github',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedPartnerClientsNewRoute =
  protectedPartnerClientsNewRouteImport.update({
    id: '/clients/new',
    path: '/clients/new',
    getParentRoute: () => protectedPartnerRouteRoute,
  } as any)
const protectedPartnerClientsClientIdRoute =
  protectedPartnerClientsClientIdRouteImport.update({
    id: '/clients/$clientId',
    path: '/clients/$clientId',
    getParentRoute: () => protectedPartnerRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdStepsIndexLazyRoute =
  protectedWorkspacesWorkspaceIdStepsIndexLazyRouteImport
    .update({
      id: '/steps/',
      path: '/steps/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/steps/index.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute =
  protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRouteImport
    .update({
      id: '/integrations/',
      path: '/integrations/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/integrations/index.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute =
  protectedWorkspacesWorkspaceIdFlowsIndexLazyRouteImport
    .update({
      id: '/flows/',
      path: '/flows/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/flows/index.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdSopsIndexRoute =
  protectedWorkspacesWorkspaceIdSopsIndexRouteImport.update({
    id: '/sops/',
    path: '/sops/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdPulseIndexRoute =
  protectedWorkspacesWorkspaceIdPulseIndexRouteImport.update({
    id: '/pulse/',
    path: '/pulse/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdDashboardIndexRoute =
  protectedWorkspacesWorkspaceIdDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdPulseConfigureRoute =
  protectedWorkspacesWorkspaceIdPulseConfigureRouteImport.update({
    id: '/pulse/configure',
    path: '/pulse/configure',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdStepsIdIndexRoute =
  protectedWorkspacesWorkspaceIdStepsIdIndexRouteImport.update({
    id: '/steps/$id/',
    path: '/steps/$id/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute =
  protectedWorkspacesWorkspaceIdSopsSopIdIndexRouteImport.update({
    id: '/sops/$sopId/',
    path: '/sops/$sopId/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute =
  protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRouteImport
    .update({
      id: '/flows/$flowId/view',
      path: '/flows/$flowId/view',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/flows/$flowId/view.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute =
  protectedWorkspacesWorkspaceIdSopsSopIdGenerateRouteImport.update({
    id: '/sops/$sopId/generate',
    path: '/sops/$sopId/generate',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/extension-uninstalled': typeof ExtensionUninstalledLazyRoute
  '/feature-board': typeof protectedFeatureBoardRouteRouteWithChildren
  '/ops': typeof protectedOpsRouteRouteWithChildren
  '/orgs': typeof protectedOrgsRouteRouteWithChildren
  '/partner': typeof protectedPartnerRouteRouteWithChildren
  '/settings': typeof protectedSettingsRouteRouteWithChildren
  '/workspaces': typeof protectedWorkspacesRouteRouteWithChildren
  '/accept-invitation': typeof authAcceptInvitationRoute
  '/login': typeof authLoginRoute
  '/logout': typeof authLogoutRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/demo/pulse': typeof DemoPulseRoute
  '/integrations/github-app-callback': typeof IntegrationsGithubAppCallbackRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/login-2': typeof authLogin2LazyRoute
  '/signup': typeof authSignupLazyRoute
  '/verify-2fa': typeof authVerify2faLazyRoute
  '/verify-otp': typeof authVerifyOtpLazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/shared-sop/$shareId': typeof SharedSopShareIdLazyRoute
  '/': typeof protectedIndexRoute
  '/orgs/$slug': typeof protectedOrgsSlugRouteRoute
  '/workspaces/$workspaceId': typeof protectedWorkspacesWorkspaceIdRouteRouteWithChildren
  '/auth-callback/$provider': typeof authAuthCallbackProviderRoute
  '/native/auth-callback': typeof authNativeAuthCallbackRoute
  '/native/login': typeof authNativeLoginRoute
  '/dev/plan-restrictions-test': typeof protectedDevPlanRestrictionsTestRoute
  '/settings/api-keys': typeof protectedSettingsApiKeysRoute
  '/settings/audit-logs': typeof protectedSettingsAuditLogsRoute
  '/settings/auth': typeof protectedSettingsAuthRoute
  '/settings/billing': typeof protectedSettingsBillingRoute
  '/settings/branding': typeof protectedSettingsBrandingRoute
  '/settings/chat': typeof protectedSettingsChatRoute
  '/settings/checks': typeof protectedSettingsChecksRoute
  '/settings/configuration': typeof protectedSettingsConfigurationRoute
  '/settings/doc-templates': typeof protectedSettingsDocTemplatesRoute
  '/settings/general': typeof protectedSettingsGeneralRoute
  '/settings/mcp-server': typeof protectedSettingsMcpServerRoute
  '/settings/members': typeof protectedSettingsMembersRoute
  '/settings/organization': typeof protectedSettingsOrganizationRoute
  '/settings/personas': typeof protectedSettingsPersonasRoute
  '/settings/profile': typeof protectedSettingsProfileRoute
  '/settings/properties': typeof protectedSettingsPropertiesRoute
  '/settings/publishing': typeof protectedSettingsPublishingRoute
  '/settings/review': typeof protectedSettingsReviewRoute
  '/settings/security': typeof protectedSettingsSecurityRoute
  '/settings/signing': typeof protectedSettingsSigningRoute
  '/settings/templates': typeof protectedSettingsTemplatesRoute
  '/settings/theme': typeof protectedSettingsThemeRoute
  '/settings/writing': typeof protectedSettingsWritingRoute
  '/workspaces/new': typeof protectedWorkspacesNewRoute
  '/demo/tiptap/ai-changes': typeof DemoTiptapAiChangesRoute
  '/demo/tiptap/ai-suggestion': typeof DemoTiptapAiSuggestionRoute
  '/feature-board/': typeof protectedFeatureBoardIndexRoute
  '/ops/': typeof protectedOpsIndexRoute
  '/partner/': typeof protectedPartnerIndexRoute
  '/settings/': typeof protectedSettingsIndexRoute
  '/tasks/': typeof protectedTasksIndexRoute
  '/demo/tiptap/': typeof DemoTiptapIndexRoute
  '/export/sop-embed/': typeof ExportSopEmbedIndexRoute
  '/export/sop-pdf/': typeof ExportSopPdfIndexRoute
  '/integrations/': typeof protectedIntegrationsIndexLazyRoute
  '/onboarding/': typeof protectedOnboardingIndexLazyRoute
  '/orgs/': typeof protectedOrgsIndexLazyRoute
  '/team/': typeof protectedTeamIndexLazyRoute
  '/workspaces/': typeof protectedWorkspacesIndexLazyRoute
  '/partner/clients/$clientId': typeof protectedPartnerClientsClientIdRoute
  '/partner/clients/new': typeof protectedPartnerClientsNewRoute
  '/workspace/integrations/github': typeof protectedWorkspaceIntegrationsGithubRoute
  '/workspaces/$workspaceId/analytics': typeof protectedWorkspacesWorkspaceIdAnalyticsRoute
  '/workspaces/$workspaceId/edit': typeof protectedWorkspacesWorkspaceIdEditRoute
  '/workspaces/$workspaceId/video-processing': typeof protectedWorkspacesWorkspaceIdVideoProcessingRoute
  '/onboarding/$organizationId/workspace': typeof protectedOnboardingOrganizationIdWorkspaceLazyRoute
  '/workspaces/$workspaceId/agent-reliability': typeof protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute
  '/workspaces/$workspaceId/git-settings': typeof protectedWorkspacesWorkspaceIdGitSettingsLazyRoute
  '/settings/service-accounts/': typeof protectedSettingsServiceAccountsIndexRoute
  '/workspace/integrations/': typeof protectedWorkspaceIntegrationsIndexRoute
  '/workspaces/$workspaceId/': typeof protectedWorkspacesWorkspaceIdIndexRoute
  '/workspaces/$workspaceId/pulse/configure': typeof protectedWorkspacesWorkspaceIdPulseConfigureRoute
  '/workspaces/$workspaceId/dashboard/': typeof protectedWorkspacesWorkspaceIdDashboardIndexRoute
  '/workspaces/$workspaceId/pulse/': typeof protectedWorkspacesWorkspaceIdPulseIndexRoute
  '/workspaces/$workspaceId/sops/': typeof protectedWorkspacesWorkspaceIdSopsIndexRoute
  '/workspaces/$workspaceId/flows/': typeof protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute
  '/workspaces/$workspaceId/integrations/': typeof protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute
  '/workspaces/$workspaceId/steps/': typeof protectedWorkspacesWorkspaceIdStepsIndexLazyRoute
  '/workspaces/$workspaceId/sops/$sopId/generate': typeof protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute
  '/workspaces/$workspaceId/flows/$flowId/view': typeof protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute
  '/workspaces/$workspaceId/sops/$sopId/': typeof protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute
  '/workspaces/$workspaceId/steps/$id/': typeof protectedWorkspacesWorkspaceIdStepsIdIndexRoute
}
export interface FileRoutesByTo {
  '/extension-uninstalled': typeof ExtensionUninstalledLazyRoute
  '/accept-invitation': typeof authAcceptInvitationRoute
  '/login': typeof authLoginRoute
  '/logout': typeof authLogoutRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/demo/pulse': typeof DemoPulseRoute
  '/integrations/github-app-callback': typeof IntegrationsGithubAppCallbackRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/login-2': typeof authLogin2LazyRoute
  '/signup': typeof authSignupLazyRoute
  '/verify-2fa': typeof authVerify2faLazyRoute
  '/verify-otp': typeof authVerifyOtpLazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/shared-sop/$shareId': typeof SharedSopShareIdLazyRoute
  '/': typeof protectedIndexRoute
  '/orgs/$slug': typeof protectedOrgsSlugRouteRoute
  '/auth-callback/$provider': typeof authAuthCallbackProviderRoute
  '/native/auth-callback': typeof authNativeAuthCallbackRoute
  '/native/login': typeof authNativeLoginRoute
  '/dev/plan-restrictions-test': typeof protectedDevPlanRestrictionsTestRoute
  '/settings/api-keys': typeof protectedSettingsApiKeysRoute
  '/settings/audit-logs': typeof protectedSettingsAuditLogsRoute
  '/settings/auth': typeof protectedSettingsAuthRoute
  '/settings/billing': typeof protectedSettingsBillingRoute
  '/settings/branding': typeof protectedSettingsBrandingRoute
  '/settings/chat': typeof protectedSettingsChatRoute
  '/settings/checks': typeof protectedSettingsChecksRoute
  '/settings/configuration': typeof protectedSettingsConfigurationRoute
  '/settings/doc-templates': typeof protectedSettingsDocTemplatesRoute
  '/settings/general': typeof protectedSettingsGeneralRoute
  '/settings/mcp-server': typeof protectedSettingsMcpServerRoute
  '/settings/members': typeof protectedSettingsMembersRoute
  '/settings/organization': typeof protectedSettingsOrganizationRoute
  '/settings/personas': typeof protectedSettingsPersonasRoute
  '/settings/profile': typeof protectedSettingsProfileRoute
  '/settings/properties': typeof protectedSettingsPropertiesRoute
  '/settings/publishing': typeof protectedSettingsPublishingRoute
  '/settings/review': typeof protectedSettingsReviewRoute
  '/settings/security': typeof protectedSettingsSecurityRoute
  '/settings/signing': typeof protectedSettingsSigningRoute
  '/settings/templates': typeof protectedSettingsTemplatesRoute
  '/settings/theme': typeof protectedSettingsThemeRoute
  '/settings/writing': typeof protectedSettingsWritingRoute
  '/workspaces/new': typeof protectedWorkspacesNewRoute
  '/demo/tiptap/ai-changes': typeof DemoTiptapAiChangesRoute
  '/demo/tiptap/ai-suggestion': typeof DemoTiptapAiSuggestionRoute
  '/feature-board': typeof protectedFeatureBoardIndexRoute
  '/ops': typeof protectedOpsIndexRoute
  '/partner': typeof protectedPartnerIndexRoute
  '/settings': typeof protectedSettingsIndexRoute
  '/tasks': typeof protectedTasksIndexRoute
  '/demo/tiptap': typeof DemoTiptapIndexRoute
  '/export/sop-embed': typeof ExportSopEmbedIndexRoute
  '/export/sop-pdf': typeof ExportSopPdfIndexRoute
  '/integrations': typeof protectedIntegrationsIndexLazyRoute
  '/onboarding': typeof protectedOnboardingIndexLazyRoute
  '/orgs': typeof protectedOrgsIndexLazyRoute
  '/team': typeof protectedTeamIndexLazyRoute
  '/workspaces': typeof protectedWorkspacesIndexLazyRoute
  '/partner/clients/$clientId': typeof protectedPartnerClientsClientIdRoute
  '/partner/clients/new': typeof protectedPartnerClientsNewRoute
  '/workspace/integrations/github': typeof protectedWorkspaceIntegrationsGithubRoute
  '/workspaces/$workspaceId/analytics': typeof protectedWorkspacesWorkspaceIdAnalyticsRoute
  '/workspaces/$workspaceId/edit': typeof protectedWorkspacesWorkspaceIdEditRoute
  '/workspaces/$workspaceId/video-processing': typeof protectedWorkspacesWorkspaceIdVideoProcessingRoute
  '/onboarding/$organizationId/workspace': typeof protectedOnboardingOrganizationIdWorkspaceLazyRoute
  '/workspaces/$workspaceId/agent-reliability': typeof protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute
  '/workspaces/$workspaceId/git-settings': typeof protectedWorkspacesWorkspaceIdGitSettingsLazyRoute
  '/settings/service-accounts': typeof protectedSettingsServiceAccountsIndexRoute
  '/workspace/integrations': typeof protectedWorkspaceIntegrationsIndexRoute
  '/workspaces/$workspaceId': typeof protectedWorkspacesWorkspaceIdIndexRoute
  '/workspaces/$workspaceId/pulse/configure': typeof protectedWorkspacesWorkspaceIdPulseConfigureRoute
  '/workspaces/$workspaceId/dashboard': typeof protectedWorkspacesWorkspaceIdDashboardIndexRoute
  '/workspaces/$workspaceId/pulse': typeof protectedWorkspacesWorkspaceIdPulseIndexRoute
  '/workspaces/$workspaceId/sops': typeof protectedWorkspacesWorkspaceIdSopsIndexRoute
  '/workspaces/$workspaceId/flows': typeof protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute
  '/workspaces/$workspaceId/integrations': typeof protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute
  '/workspaces/$workspaceId/steps': typeof protectedWorkspacesWorkspaceIdStepsIndexLazyRoute
  '/workspaces/$workspaceId/sops/$sopId/generate': typeof protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute
  '/workspaces/$workspaceId/flows/$flowId/view': typeof protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute
  '/workspaces/$workspaceId/sops/$sopId': typeof protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute
  '/workspaces/$workspaceId/steps/$id': typeof protectedWorkspacesWorkspaceIdStepsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)': typeof authRouteRouteWithChildren
  '/(protected)': typeof protectedRouteRouteWithChildren
  '/extension-uninstalled': typeof ExtensionUninstalledLazyRoute
  '/(protected)/feature-board': typeof protectedFeatureBoardRouteRouteWithChildren
  '/(protected)/ops': typeof protectedOpsRouteRouteWithChildren
  '/(protected)/orgs': typeof protectedOrgsRouteRouteWithChildren
  '/(protected)/partner': typeof protectedPartnerRouteRouteWithChildren
  '/(protected)/settings': typeof protectedSettingsRouteRouteWithChildren
  '/(protected)/workspaces': typeof protectedWorkspacesRouteRouteWithChildren
  '/(auth)/accept-invitation': typeof authAcceptInvitationRoute
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/logout': typeof authLogoutRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/verify-email': typeof authVerifyEmailRoute
  '/demo/pulse': typeof DemoPulseRoute
  '/integrations/github-app-callback': typeof IntegrationsGithubAppCallbackRoute
  '/(auth)/forgot-password': typeof authForgotPasswordLazyRoute
  '/(auth)/login-2': typeof authLogin2LazyRoute
  '/(auth)/signup': typeof authSignupLazyRoute
  '/(auth)/verify-2fa': typeof authVerify2faLazyRoute
  '/(auth)/verify-otp': typeof authVerifyOtpLazyRoute
  '/(errors)/401': typeof errors401LazyRoute
  '/(errors)/403': typeof errors403LazyRoute
  '/(errors)/404': typeof errors404LazyRoute
  '/(errors)/500': typeof errors500LazyRoute
  '/(errors)/503': typeof errors503LazyRoute
  '/shared-sop/$shareId': typeof SharedSopShareIdLazyRoute
  '/(protected)/': typeof protectedIndexRoute
  '/(protected)/orgs/$slug': typeof protectedOrgsSlugRouteRoute
  '/(protected)/workspaces/$workspaceId': typeof protectedWorkspacesWorkspaceIdRouteRouteWithChildren
  '/(auth)/auth-callback/$provider': typeof authAuthCallbackProviderRoute
  '/(auth)/native/auth-callback': typeof authNativeAuthCallbackRoute
  '/(auth)/native/login': typeof authNativeLoginRoute
  '/(protected)/dev/plan-restrictions-test': typeof protectedDevPlanRestrictionsTestRoute
  '/(protected)/settings/api-keys': typeof protectedSettingsApiKeysRoute
  '/(protected)/settings/audit-logs': typeof protectedSettingsAuditLogsRoute
  '/(protected)/settings/auth': typeof protectedSettingsAuthRoute
  '/(protected)/settings/billing': typeof protectedSettingsBillingRoute
  '/(protected)/settings/branding': typeof protectedSettingsBrandingRoute
  '/(protected)/settings/chat': typeof protectedSettingsChatRoute
  '/(protected)/settings/checks': typeof protectedSettingsChecksRoute
  '/(protected)/settings/configuration': typeof protectedSettingsConfigurationRoute
  '/(protected)/settings/doc-templates': typeof protectedSettingsDocTemplatesRoute
  '/(protected)/settings/general': typeof protectedSettingsGeneralRoute
  '/(protected)/settings/mcp-server': typeof protectedSettingsMcpServerRoute
  '/(protected)/settings/members': typeof protectedSettingsMembersRoute
  '/(protected)/settings/organization': typeof protectedSettingsOrganizationRoute
  '/(protected)/settings/personas': typeof protectedSettingsPersonasRoute
  '/(protected)/settings/profile': typeof protectedSettingsProfileRoute
  '/(protected)/settings/properties': typeof protectedSettingsPropertiesRoute
  '/(protected)/settings/publishing': typeof protectedSettingsPublishingRoute
  '/(protected)/settings/review': typeof protectedSettingsReviewRoute
  '/(protected)/settings/security': typeof protectedSettingsSecurityRoute
  '/(protected)/settings/signing': typeof protectedSettingsSigningRoute
  '/(protected)/settings/templates': typeof protectedSettingsTemplatesRoute
  '/(protected)/settings/theme': typeof protectedSettingsThemeRoute
  '/(protected)/settings/writing': typeof protectedSettingsWritingRoute
  '/(protected)/workspaces/new': typeof protectedWorkspacesNewRoute
  '/demo/tiptap/ai-changes': typeof DemoTiptapAiChangesRoute
  '/demo/tiptap/ai-suggestion': typeof DemoTiptapAiSuggestionRoute
  '/(protected)/feature-board/': typeof protectedFeatureBoardIndexRoute
  '/(protected)/ops/': typeof protectedOpsIndexRoute
  '/(protected)/partner/': typeof protectedPartnerIndexRoute
  '/(protected)/settings/': typeof protectedSettingsIndexRoute
  '/(protected)/tasks/': typeof protectedTasksIndexRoute
  '/demo/tiptap/': typeof DemoTiptapIndexRoute
  '/export/sop-embed/': typeof ExportSopEmbedIndexRoute
  '/export/sop-pdf/': typeof ExportSopPdfIndexRoute
  '/(protected)/integrations/': typeof protectedIntegrationsIndexLazyRoute
  '/(protected)/onboarding/': typeof protectedOnboardingIndexLazyRoute
  '/(protected)/orgs/': typeof protectedOrgsIndexLazyRoute
  '/(protected)/team/': typeof protectedTeamIndexLazyRoute
  '/(protected)/workspaces/': typeof protectedWorkspacesIndexLazyRoute
  '/(protected)/partner/clients/$clientId': typeof protectedPartnerClientsClientIdRoute
  '/(protected)/partner/clients/new': typeof protectedPartnerClientsNewRoute
  '/(protected)/workspace/integrations/github': typeof protectedWorkspaceIntegrationsGithubRoute
  '/(protected)/workspaces/$workspaceId/analytics': typeof protectedWorkspacesWorkspaceIdAnalyticsRoute
  '/(protected)/workspaces/$workspaceId/edit': typeof protectedWorkspacesWorkspaceIdEditRoute
  '/(protected)/workspaces/$workspaceId/video-processing': typeof protectedWorkspacesWorkspaceIdVideoProcessingRoute
  '/(protected)/onboarding/$organizationId/workspace': typeof protectedOnboardingOrganizationIdWorkspaceLazyRoute
  '/(protected)/workspaces/$workspaceId/agent-reliability': typeof protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute
  '/(protected)/workspaces/$workspaceId/git-settings': typeof protectedWorkspacesWorkspaceIdGitSettingsLazyRoute
  '/(protected)/settings/service-accounts/': typeof protectedSettingsServiceAccountsIndexRoute
  '/(protected)/workspace/integrations/': typeof protectedWorkspaceIntegrationsIndexRoute
  '/(protected)/workspaces/$workspaceId/': typeof protectedWorkspacesWorkspaceIdIndexRoute
  '/(protected)/workspaces/$workspaceId/pulse/configure': typeof protectedWorkspacesWorkspaceIdPulseConfigureRoute
  '/(protected)/workspaces/$workspaceId/dashboard/': typeof protectedWorkspacesWorkspaceIdDashboardIndexRoute
  '/(protected)/workspaces/$workspaceId/pulse/': typeof protectedWorkspacesWorkspaceIdPulseIndexRoute
  '/(protected)/workspaces/$workspaceId/sops/': typeof protectedWorkspacesWorkspaceIdSopsIndexRoute
  '/(protected)/workspaces/$workspaceId/flows/': typeof protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute
  '/(protected)/workspaces/$workspaceId/integrations/': typeof protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute
  '/(protected)/workspaces/$workspaceId/steps/': typeof protectedWorkspacesWorkspaceIdStepsIndexLazyRoute
  '/(protected)/workspaces/$workspaceId/sops/$sopId/generate': typeof protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute
  '/(protected)/workspaces/$workspaceId/flows/$flowId/view': typeof protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute
  '/(protected)/workspaces/$workspaceId/sops/$sopId/': typeof protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute
  '/(protected)/workspaces/$workspaceId/steps/$id/': typeof protectedWorkspacesWorkspaceIdStepsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/extension-uninstalled'
    | '/feature-board'
    | '/ops'
    | '/orgs'
    | '/partner'
    | '/settings'
    | '/workspaces'
    | '/accept-invitation'
    | '/login'
    | '/logout'
    | '/otp'
    | '/reset-password'
    | '/verify-email'
    | '/demo/pulse'
    | '/integrations/github-app-callback'
    | '/forgot-password'
    | '/login-2'
    | '/signup'
    | '/verify-2fa'
    | '/verify-otp'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/shared-sop/$shareId'
    | '/'
    | '/orgs/$slug'
    | '/workspaces/$workspaceId'
    | '/auth-callback/$provider'
    | '/native/auth-callback'
    | '/native/login'
    | '/dev/plan-restrictions-test'
    | '/settings/api-keys'
    | '/settings/audit-logs'
    | '/settings/auth'
    | '/settings/billing'
    | '/settings/branding'
    | '/settings/chat'
    | '/settings/checks'
    | '/settings/configuration'
    | '/settings/doc-templates'
    | '/settings/general'
    | '/settings/mcp-server'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/personas'
    | '/settings/profile'
    | '/settings/properties'
    | '/settings/publishing'
    | '/settings/review'
    | '/settings/security'
    | '/settings/signing'
    | '/settings/templates'
    | '/settings/theme'
    | '/settings/writing'
    | '/workspaces/new'
    | '/demo/tiptap/ai-changes'
    | '/demo/tiptap/ai-suggestion'
    | '/feature-board/'
    | '/ops/'
    | '/partner/'
    | '/settings/'
    | '/tasks/'
    | '/demo/tiptap/'
    | '/export/sop-embed/'
    | '/export/sop-pdf/'
    | '/integrations/'
    | '/onboarding/'
    | '/orgs/'
    | '/team/'
    | '/workspaces/'
    | '/partner/clients/$clientId'
    | '/partner/clients/new'
    | '/workspace/integrations/github'
    | '/workspaces/$workspaceId/analytics'
    | '/workspaces/$workspaceId/edit'
    | '/workspaces/$workspaceId/video-processing'
    | '/onboarding/$organizationId/workspace'
    | '/workspaces/$workspaceId/agent-reliability'
    | '/workspaces/$workspaceId/git-settings'
    | '/settings/service-accounts/'
    | '/workspace/integrations/'
    | '/workspaces/$workspaceId/'
    | '/workspaces/$workspaceId/pulse/configure'
    | '/workspaces/$workspaceId/dashboard/'
    | '/workspaces/$workspaceId/pulse/'
    | '/workspaces/$workspaceId/sops/'
    | '/workspaces/$workspaceId/flows/'
    | '/workspaces/$workspaceId/integrations/'
    | '/workspaces/$workspaceId/steps/'
    | '/workspaces/$workspaceId/sops/$sopId/generate'
    | '/workspaces/$workspaceId/flows/$flowId/view'
    | '/workspaces/$workspaceId/sops/$sopId/'
    | '/workspaces/$workspaceId/steps/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/extension-uninstalled'
    | '/accept-invitation'
    | '/login'
    | '/logout'
    | '/otp'
    | '/reset-password'
    | '/verify-email'
    | '/demo/pulse'
    | '/integrations/github-app-callback'
    | '/forgot-password'
    | '/login-2'
    | '/signup'
    | '/verify-2fa'
    | '/verify-otp'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/shared-sop/$shareId'
    | '/'
    | '/orgs/$slug'
    | '/auth-callback/$provider'
    | '/native/auth-callback'
    | '/native/login'
    | '/dev/plan-restrictions-test'
    | '/settings/api-keys'
    | '/settings/audit-logs'
    | '/settings/auth'
    | '/settings/billing'
    | '/settings/branding'
    | '/settings/chat'
    | '/settings/checks'
    | '/settings/configuration'
    | '/settings/doc-templates'
    | '/settings/general'
    | '/settings/mcp-server'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/personas'
    | '/settings/profile'
    | '/settings/properties'
    | '/settings/publishing'
    | '/settings/review'
    | '/settings/security'
    | '/settings/signing'
    | '/settings/templates'
    | '/settings/theme'
    | '/settings/writing'
    | '/workspaces/new'
    | '/demo/tiptap/ai-changes'
    | '/demo/tiptap/ai-suggestion'
    | '/feature-board'
    | '/ops'
    | '/partner'
    | '/settings'
    | '/tasks'
    | '/demo/tiptap'
    | '/export/sop-embed'
    | '/export/sop-pdf'
    | '/integrations'
    | '/onboarding'
    | '/orgs'
    | '/team'
    | '/workspaces'
    | '/partner/clients/$clientId'
    | '/partner/clients/new'
    | '/workspace/integrations/github'
    | '/workspaces/$workspaceId/analytics'
    | '/workspaces/$workspaceId/edit'
    | '/workspaces/$workspaceId/video-processing'
    | '/onboarding/$organizationId/workspace'
    | '/workspaces/$workspaceId/agent-reliability'
    | '/workspaces/$workspaceId/git-settings'
    | '/settings/service-accounts'
    | '/workspace/integrations'
    | '/workspaces/$workspaceId'
    | '/workspaces/$workspaceId/pulse/configure'
    | '/workspaces/$workspaceId/dashboard'
    | '/workspaces/$workspaceId/pulse'
    | '/workspaces/$workspaceId/sops'
    | '/workspaces/$workspaceId/flows'
    | '/workspaces/$workspaceId/integrations'
    | '/workspaces/$workspaceId/steps'
    | '/workspaces/$workspaceId/sops/$sopId/generate'
    | '/workspaces/$workspaceId/flows/$flowId/view'
    | '/workspaces/$workspaceId/sops/$sopId'
    | '/workspaces/$workspaceId/steps/$id'
  id:
    | '__root__'
    | '/(auth)'
    | '/(protected)'
    | '/extension-uninstalled'
    | '/(protected)/feature-board'
    | '/(protected)/ops'
    | '/(protected)/orgs'
    | '/(protected)/partner'
    | '/(protected)/settings'
    | '/(protected)/workspaces'
    | '/(auth)/accept-invitation'
    | '/(auth)/login'
    | '/(auth)/logout'
    | '/(auth)/otp'
    | '/(auth)/reset-password'
    | '/(auth)/verify-email'
    | '/demo/pulse'
    | '/integrations/github-app-callback'
    | '/(auth)/forgot-password'
    | '/(auth)/login-2'
    | '/(auth)/signup'
    | '/(auth)/verify-2fa'
    | '/(auth)/verify-otp'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/shared-sop/$shareId'
    | '/(protected)/'
    | '/(protected)/orgs/$slug'
    | '/(protected)/workspaces/$workspaceId'
    | '/(auth)/auth-callback/$provider'
    | '/(auth)/native/auth-callback'
    | '/(auth)/native/login'
    | '/(protected)/dev/plan-restrictions-test'
    | '/(protected)/settings/api-keys'
    | '/(protected)/settings/audit-logs'
    | '/(protected)/settings/auth'
    | '/(protected)/settings/billing'
    | '/(protected)/settings/branding'
    | '/(protected)/settings/chat'
    | '/(protected)/settings/checks'
    | '/(protected)/settings/configuration'
    | '/(protected)/settings/doc-templates'
    | '/(protected)/settings/general'
    | '/(protected)/settings/mcp-server'
    | '/(protected)/settings/members'
    | '/(protected)/settings/organization'
    | '/(protected)/settings/personas'
    | '/(protected)/settings/profile'
    | '/(protected)/settings/properties'
    | '/(protected)/settings/publishing'
    | '/(protected)/settings/review'
    | '/(protected)/settings/security'
    | '/(protected)/settings/signing'
    | '/(protected)/settings/templates'
    | '/(protected)/settings/theme'
    | '/(protected)/settings/writing'
    | '/(protected)/workspaces/new'
    | '/demo/tiptap/ai-changes'
    | '/demo/tiptap/ai-suggestion'
    | '/(protected)/feature-board/'
    | '/(protected)/ops/'
    | '/(protected)/partner/'
    | '/(protected)/settings/'
    | '/(protected)/tasks/'
    | '/demo/tiptap/'
    | '/export/sop-embed/'
    | '/export/sop-pdf/'
    | '/(protected)/integrations/'
    | '/(protected)/onboarding/'
    | '/(protected)/orgs/'
    | '/(protected)/team/'
    | '/(protected)/workspaces/'
    | '/(protected)/partner/clients/$clientId'
    | '/(protected)/partner/clients/new'
    | '/(protected)/workspace/integrations/github'
    | '/(protected)/workspaces/$workspaceId/analytics'
    | '/(protected)/workspaces/$workspaceId/edit'
    | '/(protected)/workspaces/$workspaceId/video-processing'
    | '/(protected)/onboarding/$organizationId/workspace'
    | '/(protected)/workspaces/$workspaceId/agent-reliability'
    | '/(protected)/workspaces/$workspaceId/git-settings'
    | '/(protected)/settings/service-accounts/'
    | '/(protected)/workspace/integrations/'
    | '/(protected)/workspaces/$workspaceId/'
    | '/(protected)/workspaces/$workspaceId/pulse/configure'
    | '/(protected)/workspaces/$workspaceId/dashboard/'
    | '/(protected)/workspaces/$workspaceId/pulse/'
    | '/(protected)/workspaces/$workspaceId/sops/'
    | '/(protected)/workspaces/$workspaceId/flows/'
    | '/(protected)/workspaces/$workspaceId/integrations/'
    | '/(protected)/workspaces/$workspaceId/steps/'
    | '/(protected)/workspaces/$workspaceId/sops/$sopId/generate'
    | '/(protected)/workspaces/$workspaceId/flows/$flowId/view'
    | '/(protected)/workspaces/$workspaceId/sops/$sopId/'
    | '/(protected)/workspaces/$workspaceId/steps/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authRouteRoute: typeof authRouteRouteWithChildren
  protectedRouteRoute: typeof protectedRouteRouteWithChildren
  ExtensionUninstalledLazyRoute: typeof ExtensionUninstalledLazyRoute
  DemoPulseRoute: typeof DemoPulseRoute
  IntegrationsGithubAppCallbackRoute: typeof IntegrationsGithubAppCallbackRoute
  errors401LazyRoute: typeof errors401LazyRoute
  errors403LazyRoute: typeof errors403LazyRoute
  errors404LazyRoute: typeof errors404LazyRoute
  errors500LazyRoute: typeof errors500LazyRoute
  errors503LazyRoute: typeof errors503LazyRoute
  SharedSopShareIdLazyRoute: typeof SharedSopShareIdLazyRoute
  DemoTiptapAiChangesRoute: typeof DemoTiptapAiChangesRoute
  DemoTiptapAiSuggestionRoute: typeof DemoTiptapAiSuggestionRoute
  DemoTiptapIndexRoute: typeof DemoTiptapIndexRoute
  ExportSopEmbedIndexRoute: typeof ExportSopEmbedIndexRoute
  ExportSopPdfIndexRoute: typeof ExportSopPdfIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/extension-uninstalled': {
      id: '/extension-uninstalled'
      path: '/extension-uninstalled'
      fullPath: '/extension-uninstalled'
      preLoaderRoute: typeof ExtensionUninstalledLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)': {
      id: '/(protected)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof protectedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)/': {
      id: '/(protected)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof protectedIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/shared-sop/$shareId': {
      id: '/shared-sop/$shareId'
      path: '/shared-sop/$shareId'
      fullPath: '/shared-sop/$shareId'
      preLoaderRoute: typeof SharedSopShareIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/verify-otp': {
      id: '/(auth)/verify-otp'
      path: '/verify-otp'
      fullPath: '/verify-otp'
      preLoaderRoute: typeof authVerifyOtpLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/verify-2fa': {
      id: '/(auth)/verify-2fa'
      path: '/verify-2fa'
      fullPath: '/verify-2fa'
      preLoaderRoute: typeof authVerify2faLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/signup': {
      id: '/(auth)/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof authSignupLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/login-2': {
      id: '/(auth)/login-2'
      path: '/login-2'
      fullPath: '/login-2'
      preLoaderRoute: typeof authLogin2LazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/integrations/github-app-callback': {
      id: '/integrations/github-app-callback'
      path: '/integrations/github-app-callback'
      fullPath: '/integrations/github-app-callback'
      preLoaderRoute: typeof IntegrationsGithubAppCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/pulse': {
      id: '/demo/pulse'
      path: '/demo/pulse'
      fullPath: '/demo/pulse'
      preLoaderRoute: typeof DemoPulseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/verify-email': {
      id: '/(auth)/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof authVerifyEmailRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/logout': {
      id: '/(auth)/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof authLogoutRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/accept-invitation': {
      id: '/(auth)/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof authAcceptInvitationRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(protected)/workspaces': {
      id: '/(protected)/workspaces'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof protectedWorkspacesRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/settings': {
      id: '/(protected)/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof protectedSettingsRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/partner': {
      id: '/(protected)/partner'
      path: '/partner'
      fullPath: '/partner'
      preLoaderRoute: typeof protectedPartnerRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/orgs': {
      id: '/(protected)/orgs'
      path: '/orgs'
      fullPath: '/orgs'
      preLoaderRoute: typeof protectedOrgsRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/ops': {
      id: '/(protected)/ops'
      path: '/ops'
      fullPath: '/ops'
      preLoaderRoute: typeof protectedOpsRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/feature-board': {
      id: '/(protected)/feature-board'
      path: '/feature-board'
      fullPath: '/feature-board'
      preLoaderRoute: typeof protectedFeatureBoardRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/workspaces/': {
      id: '/(protected)/workspaces/'
      path: '/'
      fullPath: '/workspaces/'
      preLoaderRoute: typeof protectedWorkspacesIndexLazyRouteImport
      parentRoute: typeof protectedWorkspacesRouteRoute
    }
    '/(protected)/team/': {
      id: '/(protected)/team/'
      path: '/team'
      fullPath: '/team/'
      preLoaderRoute: typeof protectedTeamIndexLazyRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/orgs/': {
      id: '/(protected)/orgs/'
      path: '/'
      fullPath: '/orgs/'
      preLoaderRoute: typeof protectedOrgsIndexLazyRouteImport
      parentRoute: typeof protectedOrgsRouteRoute
    }
    '/(protected)/onboarding/': {
      id: '/(protected)/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof protectedOnboardingIndexLazyRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/integrations/': {
      id: '/(protected)/integrations/'
      path: '/integrations'
      fullPath: '/integrations/'
      preLoaderRoute: typeof protectedIntegrationsIndexLazyRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/export/sop-pdf/': {
      id: '/export/sop-pdf/'
      path: '/export/sop-pdf'
      fullPath: '/export/sop-pdf/'
      preLoaderRoute: typeof ExportSopPdfIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export/sop-embed/': {
      id: '/export/sop-embed/'
      path: '/export/sop-embed'
      fullPath: '/export/sop-embed/'
      preLoaderRoute: typeof ExportSopEmbedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/tiptap/': {
      id: '/demo/tiptap/'
      path: '/demo/tiptap'
      fullPath: '/demo/tiptap/'
      preLoaderRoute: typeof DemoTiptapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)/tasks/': {
      id: '/(protected)/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof protectedTasksIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/settings/': {
      id: '/(protected)/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof protectedSettingsIndexRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/partner/': {
      id: '/(protected)/partner/'
      path: '/'
      fullPath: '/partner/'
      preLoaderRoute: typeof protectedPartnerIndexRouteImport
      parentRoute: typeof protectedPartnerRouteRoute
    }
    '/(protected)/ops/': {
      id: '/(protected)/ops/'
      path: '/'
      fullPath: '/ops/'
      preLoaderRoute: typeof protectedOpsIndexRouteImport
      parentRoute: typeof protectedOpsRouteRoute
    }
    '/(protected)/feature-board/': {
      id: '/(protected)/feature-board/'
      path: '/'
      fullPath: '/feature-board/'
      preLoaderRoute: typeof protectedFeatureBoardIndexRouteImport
      parentRoute: typeof protectedFeatureBoardRouteRoute
    }
    '/demo/tiptap/ai-suggestion': {
      id: '/demo/tiptap/ai-suggestion'
      path: '/demo/tiptap/ai-suggestion'
      fullPath: '/demo/tiptap/ai-suggestion'
      preLoaderRoute: typeof DemoTiptapAiSuggestionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/tiptap/ai-changes': {
      id: '/demo/tiptap/ai-changes'
      path: '/demo/tiptap/ai-changes'
      fullPath: '/demo/tiptap/ai-changes'
      preLoaderRoute: typeof DemoTiptapAiChangesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)/workspaces/new': {
      id: '/(protected)/workspaces/new'
      path: '/new'
      fullPath: '/workspaces/new'
      preLoaderRoute: typeof protectedWorkspacesNewRouteImport
      parentRoute: typeof protectedWorkspacesRouteRoute
    }
    '/(protected)/settings/writing': {
      id: '/(protected)/settings/writing'
      path: '/writing'
      fullPath: '/settings/writing'
      preLoaderRoute: typeof protectedSettingsWritingRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/theme': {
      id: '/(protected)/settings/theme'
      path: '/theme'
      fullPath: '/settings/theme'
      preLoaderRoute: typeof protectedSettingsThemeRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/templates': {
      id: '/(protected)/settings/templates'
      path: '/templates'
      fullPath: '/settings/templates'
      preLoaderRoute: typeof protectedSettingsTemplatesRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/signing': {
      id: '/(protected)/settings/signing'
      path: '/signing'
      fullPath: '/settings/signing'
      preLoaderRoute: typeof protectedSettingsSigningRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/security': {
      id: '/(protected)/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof protectedSettingsSecurityRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/review': {
      id: '/(protected)/settings/review'
      path: '/review'
      fullPath: '/settings/review'
      preLoaderRoute: typeof protectedSettingsReviewRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/publishing': {
      id: '/(protected)/settings/publishing'
      path: '/publishing'
      fullPath: '/settings/publishing'
      preLoaderRoute: typeof protectedSettingsPublishingRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/properties': {
      id: '/(protected)/settings/properties'
      path: '/properties'
      fullPath: '/settings/properties'
      preLoaderRoute: typeof protectedSettingsPropertiesRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/profile': {
      id: '/(protected)/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof protectedSettingsProfileRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/personas': {
      id: '/(protected)/settings/personas'
      path: '/personas'
      fullPath: '/settings/personas'
      preLoaderRoute: typeof protectedSettingsPersonasRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/organization': {
      id: '/(protected)/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof protectedSettingsOrganizationRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/members': {
      id: '/(protected)/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof protectedSettingsMembersRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/mcp-server': {
      id: '/(protected)/settings/mcp-server'
      path: '/mcp-server'
      fullPath: '/settings/mcp-server'
      preLoaderRoute: typeof protectedSettingsMcpServerRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/general': {
      id: '/(protected)/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof protectedSettingsGeneralRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/doc-templates': {
      id: '/(protected)/settings/doc-templates'
      path: '/doc-templates'
      fullPath: '/settings/doc-templates'
      preLoaderRoute: typeof protectedSettingsDocTemplatesRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/configuration': {
      id: '/(protected)/settings/configuration'
      path: '/configuration'
      fullPath: '/settings/configuration'
      preLoaderRoute: typeof protectedSettingsConfigurationRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/checks': {
      id: '/(protected)/settings/checks'
      path: '/checks'
      fullPath: '/settings/checks'
      preLoaderRoute: typeof protectedSettingsChecksRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/chat': {
      id: '/(protected)/settings/chat'
      path: '/chat'
      fullPath: '/settings/chat'
      preLoaderRoute: typeof protectedSettingsChatRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/branding': {
      id: '/(protected)/settings/branding'
      path: '/branding'
      fullPath: '/settings/branding'
      preLoaderRoute: typeof protectedSettingsBrandingRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/billing': {
      id: '/(protected)/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof protectedSettingsBillingRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/auth': {
      id: '/(protected)/settings/auth'
      path: '/auth'
      fullPath: '/settings/auth'
      preLoaderRoute: typeof protectedSettingsAuthRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/audit-logs': {
      id: '/(protected)/settings/audit-logs'
      path: '/audit-logs'
      fullPath: '/settings/audit-logs'
      preLoaderRoute: typeof protectedSettingsAuditLogsRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/settings/api-keys': {
      id: '/(protected)/settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof protectedSettingsApiKeysRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/dev/plan-restrictions-test': {
      id: '/(protected)/dev/plan-restrictions-test'
      path: '/dev/plan-restrictions-test'
      fullPath: '/dev/plan-restrictions-test'
      preLoaderRoute: typeof protectedDevPlanRestrictionsTestRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(auth)/native/login': {
      id: '/(auth)/native/login'
      path: '/native/login'
      fullPath: '/native/login'
      preLoaderRoute: typeof authNativeLoginRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/native/auth-callback': {
      id: '/(auth)/native/auth-callback'
      path: '/native/auth-callback'
      fullPath: '/native/auth-callback'
      preLoaderRoute: typeof authNativeAuthCallbackRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/auth-callback/$provider': {
      id: '/(auth)/auth-callback/$provider'
      path: '/auth-callback/$provider'
      fullPath: '/auth-callback/$provider'
      preLoaderRoute: typeof authAuthCallbackProviderRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(protected)/workspaces/$workspaceId': {
      id: '/(protected)/workspaces/$workspaceId'
      path: '/$workspaceId'
      fullPath: '/workspaces/$workspaceId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdRouteRouteImport
      parentRoute: typeof protectedWorkspacesRouteRoute
    }
    '/(protected)/orgs/$slug': {
      id: '/(protected)/orgs/$slug'
      path: '/$slug'
      fullPath: '/orgs/$slug'
      preLoaderRoute: typeof protectedOrgsSlugRouteRouteImport
      parentRoute: typeof protectedOrgsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/': {
      id: '/(protected)/workspaces/$workspaceId/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspace/integrations/': {
      id: '/(protected)/workspace/integrations/'
      path: '/workspace/integrations'
      fullPath: '/workspace/integrations/'
      preLoaderRoute: typeof protectedWorkspaceIntegrationsIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/settings/service-accounts/': {
      id: '/(protected)/settings/service-accounts/'
      path: '/service-accounts'
      fullPath: '/settings/service-accounts/'
      preLoaderRoute: typeof protectedSettingsServiceAccountsIndexRouteImport
      parentRoute: typeof protectedSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/git-settings': {
      id: '/(protected)/workspaces/$workspaceId/git-settings'
      path: '/git-settings'
      fullPath: '/workspaces/$workspaceId/git-settings'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdGitSettingsLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/agent-reliability': {
      id: '/(protected)/workspaces/$workspaceId/agent-reliability'
      path: '/agent-reliability'
      fullPath: '/workspaces/$workspaceId/agent-reliability'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAgentReliabilityLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/onboarding/$organizationId/workspace': {
      id: '/(protected)/onboarding/$organizationId/workspace'
      path: '/onboarding/$organizationId/workspace'
      fullPath: '/onboarding/$organizationId/workspace'
      preLoaderRoute: typeof protectedOnboardingOrganizationIdWorkspaceLazyRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/video-processing': {
      id: '/(protected)/workspaces/$workspaceId/video-processing'
      path: '/video-processing'
      fullPath: '/workspaces/$workspaceId/video-processing'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdVideoProcessingRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/edit': {
      id: '/(protected)/workspaces/$workspaceId/edit'
      path: '/edit'
      fullPath: '/workspaces/$workspaceId/edit'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEditRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/analytics': {
      id: '/(protected)/workspaces/$workspaceId/analytics'
      path: '/analytics'
      fullPath: '/workspaces/$workspaceId/analytics'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAnalyticsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspace/integrations/github': {
      id: '/(protected)/workspace/integrations/github'
      path: '/workspace/integrations/github'
      fullPath: '/workspace/integrations/github'
      preLoaderRoute: typeof protectedWorkspaceIntegrationsGithubRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/partner/clients/new': {
      id: '/(protected)/partner/clients/new'
      path: '/clients/new'
      fullPath: '/partner/clients/new'
      preLoaderRoute: typeof protectedPartnerClientsNewRouteImport
      parentRoute: typeof protectedPartnerRouteRoute
    }
    '/(protected)/partner/clients/$clientId': {
      id: '/(protected)/partner/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/partner/clients/$clientId'
      preLoaderRoute: typeof protectedPartnerClientsClientIdRouteImport
      parentRoute: typeof protectedPartnerRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/steps/': {
      id: '/(protected)/workspaces/$workspaceId/steps/'
      path: '/steps'
      fullPath: '/workspaces/$workspaceId/steps/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdStepsIndexLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/integrations/': {
      id: '/(protected)/workspaces/$workspaceId/integrations/'
      path: '/integrations'
      fullPath: '/workspaces/$workspaceId/integrations/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/flows/': {
      id: '/(protected)/workspaces/$workspaceId/flows/'
      path: '/flows'
      fullPath: '/workspaces/$workspaceId/flows/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdFlowsIndexLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/sops/': {
      id: '/(protected)/workspaces/$workspaceId/sops/'
      path: '/sops'
      fullPath: '/workspaces/$workspaceId/sops/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSopsIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/pulse/': {
      id: '/(protected)/workspaces/$workspaceId/pulse/'
      path: '/pulse'
      fullPath: '/workspaces/$workspaceId/pulse/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPulseIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/dashboard/': {
      id: '/(protected)/workspaces/$workspaceId/dashboard/'
      path: '/dashboard'
      fullPath: '/workspaces/$workspaceId/dashboard/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdDashboardIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/pulse/configure': {
      id: '/(protected)/workspaces/$workspaceId/pulse/configure'
      path: '/pulse/configure'
      fullPath: '/workspaces/$workspaceId/pulse/configure'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPulseConfigureRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/steps/$id/': {
      id: '/(protected)/workspaces/$workspaceId/steps/$id/'
      path: '/steps/$id'
      fullPath: '/workspaces/$workspaceId/steps/$id/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdStepsIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/sops/$sopId/': {
      id: '/(protected)/workspaces/$workspaceId/sops/$sopId/'
      path: '/sops/$sopId'
      fullPath: '/workspaces/$workspaceId/sops/$sopId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSopsSopIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/flows/$flowId/view': {
      id: '/(protected)/workspaces/$workspaceId/flows/$flowId/view'
      path: '/flows/$flowId/view'
      fullPath: '/workspaces/$workspaceId/flows/$flowId/view'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/sops/$sopId/generate': {
      id: '/(protected)/workspaces/$workspaceId/sops/$sopId/generate'
      path: '/sops/$sopId/generate'
      fullPath: '/workspaces/$workspaceId/sops/$sopId/generate'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSopsSopIdGenerateRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
  }
}

interface authRouteRouteChildren {
  authAcceptInvitationRoute: typeof authAcceptInvitationRoute
  authLoginRoute: typeof authLoginRoute
  authLogoutRoute: typeof authLogoutRoute
  authOtpRoute: typeof authOtpRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authVerifyEmailRoute: typeof authVerifyEmailRoute
  authForgotPasswordLazyRoute: typeof authForgotPasswordLazyRoute
  authLogin2LazyRoute: typeof authLogin2LazyRoute
  authSignupLazyRoute: typeof authSignupLazyRoute
  authVerify2faLazyRoute: typeof authVerify2faLazyRoute
  authVerifyOtpLazyRoute: typeof authVerifyOtpLazyRoute
  authAuthCallbackProviderRoute: typeof authAuthCallbackProviderRoute
  authNativeAuthCallbackRoute: typeof authNativeAuthCallbackRoute
  authNativeLoginRoute: typeof authNativeLoginRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authAcceptInvitationRoute: authAcceptInvitationRoute,
  authLoginRoute: authLoginRoute,
  authLogoutRoute: authLogoutRoute,
  authOtpRoute: authOtpRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authVerifyEmailRoute: authVerifyEmailRoute,
  authForgotPasswordLazyRoute: authForgotPasswordLazyRoute,
  authLogin2LazyRoute: authLogin2LazyRoute,
  authSignupLazyRoute: authSignupLazyRoute,
  authVerify2faLazyRoute: authVerify2faLazyRoute,
  authVerifyOtpLazyRoute: authVerifyOtpLazyRoute,
  authAuthCallbackProviderRoute: authAuthCallbackProviderRoute,
  authNativeAuthCallbackRoute: authNativeAuthCallbackRoute,
  authNativeLoginRoute: authNativeLoginRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface protectedFeatureBoardRouteRouteChildren {
  protectedFeatureBoardIndexRoute: typeof protectedFeatureBoardIndexRoute
}

const protectedFeatureBoardRouteRouteChildren: protectedFeatureBoardRouteRouteChildren =
  {
    protectedFeatureBoardIndexRoute: protectedFeatureBoardIndexRoute,
  }

const protectedFeatureBoardRouteRouteWithChildren =
  protectedFeatureBoardRouteRoute._addFileChildren(
    protectedFeatureBoardRouteRouteChildren,
  )

interface protectedOpsRouteRouteChildren {
  protectedOpsIndexRoute: typeof protectedOpsIndexRoute
}

const protectedOpsRouteRouteChildren: protectedOpsRouteRouteChildren = {
  protectedOpsIndexRoute: protectedOpsIndexRoute,
}

const protectedOpsRouteRouteWithChildren =
  protectedOpsRouteRoute._addFileChildren(protectedOpsRouteRouteChildren)

interface protectedOrgsRouteRouteChildren {
  protectedOrgsSlugRouteRoute: typeof protectedOrgsSlugRouteRoute
  protectedOrgsIndexLazyRoute: typeof protectedOrgsIndexLazyRoute
}

const protectedOrgsRouteRouteChildren: protectedOrgsRouteRouteChildren = {
  protectedOrgsSlugRouteRoute: protectedOrgsSlugRouteRoute,
  protectedOrgsIndexLazyRoute: protectedOrgsIndexLazyRoute,
}

const protectedOrgsRouteRouteWithChildren =
  protectedOrgsRouteRoute._addFileChildren(protectedOrgsRouteRouteChildren)

interface protectedPartnerRouteRouteChildren {
  protectedPartnerIndexRoute: typeof protectedPartnerIndexRoute
  protectedPartnerClientsClientIdRoute: typeof protectedPartnerClientsClientIdRoute
  protectedPartnerClientsNewRoute: typeof protectedPartnerClientsNewRoute
}

const protectedPartnerRouteRouteChildren: protectedPartnerRouteRouteChildren = {
  protectedPartnerIndexRoute: protectedPartnerIndexRoute,
  protectedPartnerClientsClientIdRoute: protectedPartnerClientsClientIdRoute,
  protectedPartnerClientsNewRoute: protectedPartnerClientsNewRoute,
}

const protectedPartnerRouteRouteWithChildren =
  protectedPartnerRouteRoute._addFileChildren(
    protectedPartnerRouteRouteChildren,
  )

interface protectedSettingsRouteRouteChildren {
  protectedSettingsApiKeysRoute: typeof protectedSettingsApiKeysRoute
  protectedSettingsAuditLogsRoute: typeof protectedSettingsAuditLogsRoute
  protectedSettingsAuthRoute: typeof protectedSettingsAuthRoute
  protectedSettingsBillingRoute: typeof protectedSettingsBillingRoute
  protectedSettingsBrandingRoute: typeof protectedSettingsBrandingRoute
  protectedSettingsChatRoute: typeof protectedSettingsChatRoute
  protectedSettingsChecksRoute: typeof protectedSettingsChecksRoute
  protectedSettingsConfigurationRoute: typeof protectedSettingsConfigurationRoute
  protectedSettingsDocTemplatesRoute: typeof protectedSettingsDocTemplatesRoute
  protectedSettingsGeneralRoute: typeof protectedSettingsGeneralRoute
  protectedSettingsMcpServerRoute: typeof protectedSettingsMcpServerRoute
  protectedSettingsMembersRoute: typeof protectedSettingsMembersRoute
  protectedSettingsOrganizationRoute: typeof protectedSettingsOrganizationRoute
  protectedSettingsPersonasRoute: typeof protectedSettingsPersonasRoute
  protectedSettingsProfileRoute: typeof protectedSettingsProfileRoute
  protectedSettingsPropertiesRoute: typeof protectedSettingsPropertiesRoute
  protectedSettingsPublishingRoute: typeof protectedSettingsPublishingRoute
  protectedSettingsReviewRoute: typeof protectedSettingsReviewRoute
  protectedSettingsSecurityRoute: typeof protectedSettingsSecurityRoute
  protectedSettingsSigningRoute: typeof protectedSettingsSigningRoute
  protectedSettingsTemplatesRoute: typeof protectedSettingsTemplatesRoute
  protectedSettingsThemeRoute: typeof protectedSettingsThemeRoute
  protectedSettingsWritingRoute: typeof protectedSettingsWritingRoute
  protectedSettingsIndexRoute: typeof protectedSettingsIndexRoute
  protectedSettingsServiceAccountsIndexRoute: typeof protectedSettingsServiceAccountsIndexRoute
}

const protectedSettingsRouteRouteChildren: protectedSettingsRouteRouteChildren =
  {
    protectedSettingsApiKeysRoute: protectedSettingsApiKeysRoute,
    protectedSettingsAuditLogsRoute: protectedSettingsAuditLogsRoute,
    protectedSettingsAuthRoute: protectedSettingsAuthRoute,
    protectedSettingsBillingRoute: protectedSettingsBillingRoute,
    protectedSettingsBrandingRoute: protectedSettingsBrandingRoute,
    protectedSettingsChatRoute: protectedSettingsChatRoute,
    protectedSettingsChecksRoute: protectedSettingsChecksRoute,
    protectedSettingsConfigurationRoute: protectedSettingsConfigurationRoute,
    protectedSettingsDocTemplatesRoute: protectedSettingsDocTemplatesRoute,
    protectedSettingsGeneralRoute: protectedSettingsGeneralRoute,
    protectedSettingsMcpServerRoute: protectedSettingsMcpServerRoute,
    protectedSettingsMembersRoute: protectedSettingsMembersRoute,
    protectedSettingsOrganizationRoute: protectedSettingsOrganizationRoute,
    protectedSettingsPersonasRoute: protectedSettingsPersonasRoute,
    protectedSettingsProfileRoute: protectedSettingsProfileRoute,
    protectedSettingsPropertiesRoute: protectedSettingsPropertiesRoute,
    protectedSettingsPublishingRoute: protectedSettingsPublishingRoute,
    protectedSettingsReviewRoute: protectedSettingsReviewRoute,
    protectedSettingsSecurityRoute: protectedSettingsSecurityRoute,
    protectedSettingsSigningRoute: protectedSettingsSigningRoute,
    protectedSettingsTemplatesRoute: protectedSettingsTemplatesRoute,
    protectedSettingsThemeRoute: protectedSettingsThemeRoute,
    protectedSettingsWritingRoute: protectedSettingsWritingRoute,
    protectedSettingsIndexRoute: protectedSettingsIndexRoute,
    protectedSettingsServiceAccountsIndexRoute:
      protectedSettingsServiceAccountsIndexRoute,
  }

const protectedSettingsRouteRouteWithChildren =
  protectedSettingsRouteRoute._addFileChildren(
    protectedSettingsRouteRouteChildren,
  )

interface protectedWorkspacesWorkspaceIdRouteRouteChildren {
  protectedWorkspacesWorkspaceIdAnalyticsRoute: typeof protectedWorkspacesWorkspaceIdAnalyticsRoute
  protectedWorkspacesWorkspaceIdEditRoute: typeof protectedWorkspacesWorkspaceIdEditRoute
  protectedWorkspacesWorkspaceIdVideoProcessingRoute: typeof protectedWorkspacesWorkspaceIdVideoProcessingRoute
  protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute: typeof protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute
  protectedWorkspacesWorkspaceIdGitSettingsLazyRoute: typeof protectedWorkspacesWorkspaceIdGitSettingsLazyRoute
  protectedWorkspacesWorkspaceIdIndexRoute: typeof protectedWorkspacesWorkspaceIdIndexRoute
  protectedWorkspacesWorkspaceIdPulseConfigureRoute: typeof protectedWorkspacesWorkspaceIdPulseConfigureRoute
  protectedWorkspacesWorkspaceIdDashboardIndexRoute: typeof protectedWorkspacesWorkspaceIdDashboardIndexRoute
  protectedWorkspacesWorkspaceIdPulseIndexRoute: typeof protectedWorkspacesWorkspaceIdPulseIndexRoute
  protectedWorkspacesWorkspaceIdSopsIndexRoute: typeof protectedWorkspacesWorkspaceIdSopsIndexRoute
  protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute: typeof protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute
  protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute
  protectedWorkspacesWorkspaceIdStepsIndexLazyRoute: typeof protectedWorkspacesWorkspaceIdStepsIndexLazyRoute
  protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute: typeof protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute
  protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute: typeof protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute
  protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute: typeof protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute
  protectedWorkspacesWorkspaceIdStepsIdIndexRoute: typeof protectedWorkspacesWorkspaceIdStepsIdIndexRoute
}

const protectedWorkspacesWorkspaceIdRouteRouteChildren: protectedWorkspacesWorkspaceIdRouteRouteChildren =
  {
    protectedWorkspacesWorkspaceIdAnalyticsRoute:
      protectedWorkspacesWorkspaceIdAnalyticsRoute,
    protectedWorkspacesWorkspaceIdEditRoute:
      protectedWorkspacesWorkspaceIdEditRoute,
    protectedWorkspacesWorkspaceIdVideoProcessingRoute:
      protectedWorkspacesWorkspaceIdVideoProcessingRoute,
    protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute:
      protectedWorkspacesWorkspaceIdAgentReliabilityLazyRoute,
    protectedWorkspacesWorkspaceIdGitSettingsLazyRoute:
      protectedWorkspacesWorkspaceIdGitSettingsLazyRoute,
    protectedWorkspacesWorkspaceIdIndexRoute:
      protectedWorkspacesWorkspaceIdIndexRoute,
    protectedWorkspacesWorkspaceIdPulseConfigureRoute:
      protectedWorkspacesWorkspaceIdPulseConfigureRoute,
    protectedWorkspacesWorkspaceIdDashboardIndexRoute:
      protectedWorkspacesWorkspaceIdDashboardIndexRoute,
    protectedWorkspacesWorkspaceIdPulseIndexRoute:
      protectedWorkspacesWorkspaceIdPulseIndexRoute,
    protectedWorkspacesWorkspaceIdSopsIndexRoute:
      protectedWorkspacesWorkspaceIdSopsIndexRoute,
    protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute:
      protectedWorkspacesWorkspaceIdFlowsIndexLazyRoute,
    protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute:
      protectedWorkspacesWorkspaceIdIntegrationsIndexLazyRoute,
    protectedWorkspacesWorkspaceIdStepsIndexLazyRoute:
      protectedWorkspacesWorkspaceIdStepsIndexLazyRoute,
    protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute:
      protectedWorkspacesWorkspaceIdSopsSopIdGenerateRoute,
    protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute:
      protectedWorkspacesWorkspaceIdFlowsFlowIdViewLazyRoute,
    protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute:
      protectedWorkspacesWorkspaceIdSopsSopIdIndexRoute,
    protectedWorkspacesWorkspaceIdStepsIdIndexRoute:
      protectedWorkspacesWorkspaceIdStepsIdIndexRoute,
  }

const protectedWorkspacesWorkspaceIdRouteRouteWithChildren =
  protectedWorkspacesWorkspaceIdRouteRoute._addFileChildren(
    protectedWorkspacesWorkspaceIdRouteRouteChildren,
  )

interface protectedWorkspacesRouteRouteChildren {
  protectedWorkspacesWorkspaceIdRouteRoute: typeof protectedWorkspacesWorkspaceIdRouteRouteWithChildren
  protectedWorkspacesNewRoute: typeof protectedWorkspacesNewRoute
  protectedWorkspacesIndexLazyRoute: typeof protectedWorkspacesIndexLazyRoute
}

const protectedWorkspacesRouteRouteChildren: protectedWorkspacesRouteRouteChildren =
  {
    protectedWorkspacesWorkspaceIdRouteRoute:
      protectedWorkspacesWorkspaceIdRouteRouteWithChildren,
    protectedWorkspacesNewRoute: protectedWorkspacesNewRoute,
    protectedWorkspacesIndexLazyRoute: protectedWorkspacesIndexLazyRoute,
  }

const protectedWorkspacesRouteRouteWithChildren =
  protectedWorkspacesRouteRoute._addFileChildren(
    protectedWorkspacesRouteRouteChildren,
  )

interface protectedRouteRouteChildren {
  protectedFeatureBoardRouteRoute: typeof protectedFeatureBoardRouteRouteWithChildren
  protectedOpsRouteRoute: typeof protectedOpsRouteRouteWithChildren
  protectedOrgsRouteRoute: typeof protectedOrgsRouteRouteWithChildren
  protectedPartnerRouteRoute: typeof protectedPartnerRouteRouteWithChildren
  protectedSettingsRouteRoute: typeof protectedSettingsRouteRouteWithChildren
  protectedWorkspacesRouteRoute: typeof protectedWorkspacesRouteRouteWithChildren
  protectedIndexRoute: typeof protectedIndexRoute
  protectedDevPlanRestrictionsTestRoute: typeof protectedDevPlanRestrictionsTestRoute
  protectedTasksIndexRoute: typeof protectedTasksIndexRoute
  protectedIntegrationsIndexLazyRoute: typeof protectedIntegrationsIndexLazyRoute
  protectedOnboardingIndexLazyRoute: typeof protectedOnboardingIndexLazyRoute
  protectedTeamIndexLazyRoute: typeof protectedTeamIndexLazyRoute
  protectedWorkspaceIntegrationsGithubRoute: typeof protectedWorkspaceIntegrationsGithubRoute
  protectedOnboardingOrganizationIdWorkspaceLazyRoute: typeof protectedOnboardingOrganizationIdWorkspaceLazyRoute
  protectedWorkspaceIntegrationsIndexRoute: typeof protectedWorkspaceIntegrationsIndexRoute
}

const protectedRouteRouteChildren: protectedRouteRouteChildren = {
  protectedFeatureBoardRouteRoute: protectedFeatureBoardRouteRouteWithChildren,
  protectedOpsRouteRoute: protectedOpsRouteRouteWithChildren,
  protectedOrgsRouteRoute: protectedOrgsRouteRouteWithChildren,
  protectedPartnerRouteRoute: protectedPartnerRouteRouteWithChildren,
  protectedSettingsRouteRoute: protectedSettingsRouteRouteWithChildren,
  protectedWorkspacesRouteRoute: protectedWorkspacesRouteRouteWithChildren,
  protectedIndexRoute: protectedIndexRoute,
  protectedDevPlanRestrictionsTestRoute: protectedDevPlanRestrictionsTestRoute,
  protectedTasksIndexRoute: protectedTasksIndexRoute,
  protectedIntegrationsIndexLazyRoute: protectedIntegrationsIndexLazyRoute,
  protectedOnboardingIndexLazyRoute: protectedOnboardingIndexLazyRoute,
  protectedTeamIndexLazyRoute: protectedTeamIndexLazyRoute,
  protectedWorkspaceIntegrationsGithubRoute:
    protectedWorkspaceIntegrationsGithubRoute,
  protectedOnboardingOrganizationIdWorkspaceLazyRoute:
    protectedOnboardingOrganizationIdWorkspaceLazyRoute,
  protectedWorkspaceIntegrationsIndexRoute:
    protectedWorkspaceIntegrationsIndexRoute,
}

const protectedRouteRouteWithChildren = protectedRouteRoute._addFileChildren(
  protectedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  authRouteRoute: authRouteRouteWithChildren,
  protectedRouteRoute: protectedRouteRouteWithChildren,
  ExtensionUninstalledLazyRoute: ExtensionUninstalledLazyRoute,
  DemoPulseRoute: DemoPulseRoute,
  IntegrationsGithubAppCallbackRoute: IntegrationsGithubAppCallbackRoute,
  errors401LazyRoute: errors401LazyRoute,
  errors403LazyRoute: errors403LazyRoute,
  errors404LazyRoute: errors404LazyRoute,
  errors500LazyRoute: errors500LazyRoute,
  errors503LazyRoute: errors503LazyRoute,
  SharedSopShareIdLazyRoute: SharedSopShareIdLazyRoute,
  DemoTiptapAiChangesRoute: DemoTiptapAiChangesRoute,
  DemoTiptapAiSuggestionRoute: DemoTiptapAiSuggestionRoute,
  DemoTiptapIndexRoute: DemoTiptapIndexRoute,
  ExportSopEmbedIndexRoute: ExportSopEmbedIndexRoute,
  ExportSopPdfIndexRoute: ExportSopPdfIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
